/** Parte calendario YYYY-MM-DD de un valor fecha API (date o timestamptz). */
function dateOnlyPart(value: string | null | undefined): string | null {
	if (value == null || value === '') return null;
	const s = String(value).trim();
	const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
	return m ? m[1] : null;
}

/** Normaliza hora legacy (HH:mm o HH:mm:ss) para combinar con fecha. */
function normalizeTime(hour: string | null | undefined): string {
	if (hour == null || hour === '') return '00:00:00';
	const t = String(hour).trim();
	if (/^\d{2}:\d{2}:\d{2}/.test(t)) return t.slice(0, 8);
	if (/^\d{2}:\d{2}$/.test(t)) return `${t}:00`;
	return t;
}

export type ActivityInstantSource = {
	activity_at?: string | null;
	date_activity?: string | null;
	hour_activity?: string | null;
};

export type AlertInstantSource = {
	alert_at?: string | null;
	date_before_activity?: string | null;
	hour_before_activity?: string | null;
};

/** ISO instante de actividad: `activity_at` o legacy fecha+hora. */
export function resolveActivityInstant(
	activity: ActivityInstantSource | null | undefined
): string | null {
	if (!activity) return null;
	if (activity.activity_at) return String(activity.activity_at).trim();
	const date = dateOnlyPart(activity.date_activity);
	if (date && activity.hour_activity) {
		return `${date}T${normalizeTime(activity.hour_activity)}`;
	}
	if (date) return date;
	return null;
}

/** ISO instante de alerta: `alert_at` o legacy fecha+hora. */
export function resolveAlertInstant(
	alert: AlertInstantSource | null | undefined
): string | null {
	if (!alert) return null;
	if (alert.alert_at) return String(alert.alert_at).trim();
	const date = dateOnlyPart(alert.date_before_activity);
	if (date && alert.hour_before_activity) {
		return `${date}T${normalizeTime(alert.hour_before_activity)}`;
	}
	if (date) return date;
	return null;
}
